import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './RestockBadge.css';

/**
 * Daily restock messaging — pulls from /api/seo/stats/restock.
 * Shows "N SKUs restocked in the last 24h" by default, falls back to
 * "N products in stock" when no recent activity is detected so customers
 * always see a live inventory signal.
 */
export default function RestockBadge() {
  const [data, setData] = useState(null);
  useEffect(() => {
    fetch('/api/seo/stats/restock')
      .then(r => r.ok ? r.json() : null)
      .then(d => setData(d))
      .catch(() => {});
  }, []);
  if (!data || !data.count) return null;
  const isFallback = data.fallback === 'in_stock_total';
  const label = isFallback
    ? `${data.count} product${data.count === 1 ? '' : 's'} in stock`
    : `${data.count} SKU${data.count === 1 ? '' : 's'} restocked in the last 24h`;
  return (
    <Link to="/shop?sort=created_at_desc&in_stock=true" className="restock-badge" aria-label={label}>
      <span className="restock-badge__pulse" aria-hidden="true" />
      <span><strong>{data.count}</strong> {isFallback
        ? `product${data.count === 1 ? '' : 's'} in stock`
        : `SKU${data.count === 1 ? '' : 's'} restocked in the last 24h`}</span>
      <span className="restock-badge__cta">View →</span>
    </Link>
  );
}
